import { Box, Typography, Grid, Tooltip, Button } from "@mui/material";
import { Container, KeyValueText, KeyTxt } from "../styledComponent/Common";
import moment from "moment";
import { NoImage } from "../utility/ImgNIcons";
import { DocumentTypes } from "../../pages/customer/CustomerConstants";
import CustomerInfoText from "./customerInfoText";
import { useState } from "react";
import ImagePreview from "../modal/ImagePreview";
import { useLocation } from "react-router-dom";

const CustomerDetail = ({ isApproved, customer, loading, isPrint }: { isApproved?: any, customer?: any, loading?: boolean, isPrint?: boolean }) => {
    return (
        <Container sx={{ width: "100%" }}>
            <Grid container>
                <Grid xs={9} item>
                    <DetailsSection isApproved={isApproved} customer={customer} loading={loading} isPrint={isPrint} />
                </Grid>
                <Grid xs={3} item>
                    <PhotoSection customer={customer} loading={loading} isPrint={isPrint} />
                </Grid>
            </Grid>
        </Container>
    );
}

const PhotoSection = ({ customer, loading, isPrint }: { customer: any, loading?: boolean, isPrint?: boolean }) => {
    const [tempImage, setTempImage] = useState<boolean>(false)
    return (
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end", gap: "5px", alignItems: "center" }}>
            <img style={{ alignItems: "center !important", borderRadius: "5px", objectFit: "contain", width: `${isPrint ? "150px" : "250px"}`, height: `${isPrint ? "150px" : "250px"}`, maxWidth: "250px", maxHeight: "250px", border: tempImage ? "2px solid green" : `${isPrint ? "0px solid white" : "2px solid red"}` }} src={tempImage ? customer?.tempprofileImage : customer?.profileImage ?? customer?.tempprofileImage ?? NoImage} alt="Profile" />
            {
                !customer?.isSameprofileImage && customer?.profileImage && customer?.tempprofileImage ? <Tooltip title={tempImage ? "View Previous Image" : "View New Image"}>
                    <Button sx={{ marginLeft: "10px" }} variant="contained" color="primary" onClick={() => setTempImage(!tempImage)}>{tempImage ? "View Previous Image" : "View New Image"}</Button>
                </Tooltip> : null
            }
        </div>
    );
}

const DetailsSection = ({ isApproved, customer, loading, isPrint }: { isApproved?: any, customer: any, loading?: boolean, isPrint?: boolean }) => {
    const [imageOpen, setImageOpen] = useState<boolean>(false)
    const [imageSrc, setImageSrc] = useState<string>('')
    const [tempImage, setTempImage] = useState<boolean>(false)
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isMainTable = queryParams.get('isMainTable');
    return (
        <>
            <Box>
                <Typography component="div" mb={1} sx={{ color: "black", fontWeight: "500", fontSize: "16px" }}>
                    Personal Information
                </Typography>
                {!loading && customer?.tempisActive !== undefined && !customer?.tempisActive ? <Typography sx={{ color: 'red', marginTop: '5px', fontSize: '12px' }}>Account is set to deactivate.</Typography> : null}

                <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                        <KeyValueText>
                            <KeyTxt>Account number:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSameaccountNumber} value={customer?.accountNumber} tempValue={customer?.tempaccountNumber} />
                        </KeyValueText>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <KeyValueText>
                            <KeyTxt>Fullname:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSamefirstName || !customer?.isSamemiddleName || !customer?.isSamelastName} value={`${customer?.firstName} ${customer?.middleName ?? ''} ${customer?.lastName}`} tempValue={`${customer?.tempfirstName} ${customer?.tempmiddleName ?? ''} ${customer?.templastName}`} />
                        </KeyValueText>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <KeyValueText>
                            <KeyTxt>Mobile No:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSamemobileNumber} value={customer?.mobileNumber} tempValue={customer?.tempmobileNumber} />
                        </KeyValueText>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <KeyValueText>
                            <KeyTxt>Email:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSameemail} value={customer?.email} tempValue={customer?.tempemail} />
                        </KeyValueText>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <KeyValueText>
                            <KeyTxt>Date of Birth:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSamedob} value={customer?.dob ? moment(customer?.dob).format('YYYY/M/D') : ''} tempValue={customer?.tempdob ? moment(customer?.tempdob).format('YYYY/M/D') : ''} />
                        </KeyValueText>
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ marginTop: `${isPrint ? "15px" : "40px"}` }}>
                <Typography component="div" mb={1} sx={{ color: "black", fontWeight: "500", fontSize: "16px" }}>
                    Document Information
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                        <KeyValueText>
                            <KeyTxt>Document Type:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSamedocType} value={DocumentTypes[customer?.docType]} tempValue={customer?.tempdocType ? DocumentTypes[customer?.tempdocType] : ''} />
                        </KeyValueText>
                        {isPrint ? null : <img style={{ alignItems: "center !important", borderRadius: "5px", border: tempImage ? "2px solid green" : "2px solid red", objectFit: "contain", width: `${isPrint ? "150px" : "250px"}`, height: `${isPrint ? "150px" : "250px"}`, maxWidth: "250px", maxHeight: "250px" }} src={tempImage ? customer?.tempdocPhotoUrl : customer?.docPhotoUrl ?? customer?.tempdocPhotoUrl ?? NoImage} alt="Document" onClick={() => {
                            if (customer?.docPhotoUrl) {
                                setImageSrc(tempImage ? customer?.tempdocPhotoUrl : customer?.docPhotoUrl)
                                setImageOpen(true)
                            }
                        }} />}

                        {
                            !customer?.isSamedocPhotoUrl && customer?.docPhotoUrl && customer?.tempdocPhotoUrl ? <Tooltip title={tempImage ? "View Previous Doc" : "View New Doc"}>
                                <Button sx={{ marginLeft: "10px" }} variant="contained" color="primary" onClick={() => setTempImage(!tempImage)}>{tempImage ? "View Previous Doc" : "View New Doc"}</Button>
                            </Tooltip> : null
                        }

                    </Grid>
                    <Grid item xs={6} md={6}>
                        <KeyValueText>
                            <KeyTxt>Document No:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSamedocId} value={customer?.docId} tempValue={customer?.tempdocId} />
                        </KeyValueText>
                    </Grid>
                </Grid>
            </Box >
            <Box sx={{ marginTop: `${isPrint ? "15px" : "40px"}` }}>
                <Typography component="div" mb={1} sx={{ color: "black", fontWeight: "500", fontSize: "16px" }}>
                    Address Information
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                        <KeyValueText>
                            <KeyTxt>Temporary Address:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSamepermanentAddress} value={customer?.permanentAddress} tempValue={customer?.temppermanentAddress} />
                        </KeyValueText>
                    </Grid>
                    <Grid item xs={6} md={6}>
                        <KeyValueText>
                            <KeyTxt>Permanent Address:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSametemporaryAddress} value={customer?.temporaryAddress} tempValue={customer?.temptemporaryAddress} />
                        </KeyValueText>
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ marginTop: `${isPrint ? "15px" : "40px"}` }}>
                <Typography component="div" mb={1} sx={{ color: "black", fontWeight: "500", fontSize: "16px" }}>
                    Family Information
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={isPrint ? 4 : 6} md={isPrint ? 4 : 6}>
                        <KeyValueText>
                            <KeyTxt>Father's Name:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSamefatherName} value={customer?.fatherName} tempValue={customer?.tempfatherName} />
                        </KeyValueText>
                    </Grid>
                    <Grid item xs={isPrint ? 4 : 6} md={isPrint ? 4 : 6}>
                        <KeyValueText>
                            <KeyTxt>Mother's Name:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSamemotherName} value={customer?.motherName} tempValue={customer?.tempmotherName} />
                        </KeyValueText>
                    </Grid>
                    <Grid item xs={isPrint ? 4 : 6} md={isPrint ? 4 : 6}>
                        <KeyValueText>
                            <KeyTxt>Spouse Name:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSamespouseName} value={customer?.spouseName} tempValue={customer?.tempspouseName} />
                        </KeyValueText>
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ marginTop: `${isPrint ? "15px" : "40px"}` }}>
                <Typography component="div" mb={1} sx={{ color: "black", fontWeight: "500", fontSize: "16px" }}>
                    Locker Security
                </Typography>

                <Grid container spacing={2}>
                    <Grid item xs={6} md={6}>
                        <KeyValueText>
                            <KeyTxt>Application Number:</KeyTxt>
                            <CustomerInfoText loading={loading} isSame={!customer?.isSameapplicationNumber} value={customer?.applicationNumber} tempValue={customer?.tempapplicationNumber} />
                        </KeyValueText>
                    </Grid>

                </Grid>
                {isMainTable && isApproved === false && !customer?.tempisSamepasscode ? <Typography sx={{ color: 'red', marginTop: '5px', fontSize: '12px' }}>Passcode Changed</Typography> : null}
            </Box>
            {
                customer?.tempisReject === true && isMainTable === 'false' ? <Box sx={{ marginTop: `${isPrint ? "15px" : "40px"}` }}>
                    <Typography component="div" mb={1} sx={{ color: "black", fontWeight: "500", fontSize: "16px" }}>
                        Rejection Reason
                    </Typography>

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <KeyValueText>
                                <Typography sx={{ color: 'red', fontSize: '12px' }}>{customer?.tempremarks}</Typography>
                            </KeyValueText>
                        </Grid>
                    </Grid>
                </Box> : null
            }
            {
                !customer?.isSameisFingerChanged ? <Box sx={{ marginTop: `${isPrint ? "15px" : "40px"}` }}>
                    <Typography component="div" mb={1} sx={{ color: "black", fontWeight: "500", fontSize: "16px" }}>
                        Biometric
                    </Typography>
                    <Typography sx={{ color: 'red', marginTop: '5px', fontSize: '12px' }}>Biometric Changed</Typography>
                </Box> : null
            }
            <ImagePreview open={imageOpen} setOpen={setImageOpen} imageSrc={imageSrc} />
        </>
    );
}

export default CustomerDetail;
